import { getCategories, getData, getTeachers } from "@/Services/api/HelpersServices";

export default {
  //namespaced: true,
  state: {
    categories: [],
    instructors: [],
    selectedInstructors: [],
    selectedCategories: [],
    global : null,
    landingSettings : null,
    isLoading : false,
    searchTerm :'',
    packagesCount: null,
    promotion: null,
    coursesCount: null,
    websiteSettings : null
  },
  getters: {
    categories(state) {
      return state.categories;
    },
    selectedCategories(state) {
      return state.selectedCategories;
    },
    instructors(state) {
      return state.instructors;
    },
    selectedInstructors(state) {
      return state.selectedInstructors;
    },
    global(state){
      return state.global
    },
    landingSettings(state){
      return state.landingSettings
    },
    isLoadingGlobal(state){
      return state.isLoading
    },
    searchTerm(state){
      return state.searchTerm
    },
    packagesCount(state){
      return state.packagesCount
    },
    coursesCount(state){
      return state.coursesCount
    },
    getPromotion(state){
      return state.promotion
    },
    getSettings(state){
      return state.websiteSettings
    }
  },
  mutations: {
    setCategories(state, payload) {
      state.categories = payload;
    },
    setSelectedCategories(state, selectedCategories) {
      state.selectedCategories = selectedCategories;
    },
    setInstructors(state, payload) {
      state.instructors = payload;
    },
    setSelectedInstructors(state, payload) {
      state.selectedInstructors = payload;
    },
    setGlobal(state,payload){
      state.global = payload
    },
    setlandingSettings(state,payload){
      state.landingSettings = payload
    },
    setIsLoading(state , payload){
      state.isLoading = payload;
    },
    setSearchTerm(state, payload){
      state.searchTerm = payload
    },
    setCoursesCount(state, payload){
      state.coursesCount = payload
    },
    setPackagesCount(state, payload){
      state.packagesCount = payload
    },
    setPromotion(state, payload){
      state.promotion = payload
    },
    setWebsiteSettings(state, payload){
      state.websiteSettings = payload
    }
  },
  actions: {
    // Get Categories
    async categoriesList({ commit }) {
      try {
        const response = await getCategories();
        commit("setCategories", response.data); 
      } catch (error) {
        console.log("Error fetching categories:", error); 
      }
    },

    // Get Instructors
    async instructorsList({ commit }) {
      try {
        const response = await getTeachers();
        commit("setInstructors", response.data);
      } catch (error) {
        console.log("Error fetching instructors:", error); 
      }
    },

    //selected Categories
    addSelectedInstructor({ commit }, payload) {
      commit("setSelectedInstructors", payload);
    },

    //selected Categories
    addSelectedCatgories({ commit }, payload) {
      commit("setSelectedCategories", payload);
    },

    //Get Global data
    async GlobalData({ commit }){
      commit('setIsLoading', true);
      try{
        let response = await getData();
        commit('setGlobal',response.data);
        commit('setlandingSettings', response.data['landing-settings']);
        commit('setCoursesCount',response.data.counts)
        commit('setPromotion', response.data.promotion)
        commit('setWebsiteSettings',response.data.settings)
      }catch(error){
        console.log(error)
      }finally{
        commit('setIsLoading',false);
      }
    }
  },
};
